var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.showLogin)?_c('LoginForm'):_c('posLoginForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }